import React from 'react';
import { Input, message, Icon } from 'antd';
import { getStringLength } from 'utils/utils.js';
import { connect } from 'dva';
import styles from './Index.less';

@connect(() => ({}))
export default class SkusChildItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleDel = this.handleDel.bind(this);

    // 是否操作了删除标志
    this.isDel = false;

    this.state = {
      value: props.value,
    };
  }

  componentDidMount() {
    const { value } = this.state;
    // 新添加的子规格输入框，值为空，使其自动获得焦点
    if (value === '') {
      this.valueInput.focus();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMsg !== '') {
      message.warning(nextProps.errorMsg);
      this.setState({
        value: nextProps.lastValue,
      });
    }
  }

  handleChange(e) {
    this.setState({
      value: e.target.value.trim(),
    });
  }

  // 失去焦点时更改值
  handleBlur(e) {
    const { lastValue, parentName, childSkusLength } = this.props;
    const { value } = e.target;

    // 加定时器的目的：为了避免内容为空时，点击删除时，还会报名称不能为空的提示
    setTimeout(() => {
      if (value.trim() === '' && !this.isDel) {
        // 删除该子规格
        this.props.dispatch({
          type: 'SkusEdit/modifySkusChild',
          option: 'delete',
          payload: {
            parentName,
            value,
          },
        });
        return message.warning(`规格名称不能为空`);
      }
    }, 300);

    if (lastValue === value) {
      return false;
    }

    if (getStringLength(value) > childSkusLength * 2) {
      return message.warning(`规格名称不能超过${childSkusLength}字`);
    }

    this.props.dispatch({
      type: 'SkusEdit/modifySkusChild',
      option: 'change',
      payload: {
        parentName,
        lastValue,
        value,
      },
    });
  }

  // 删除该规格
  handleDel() {
    this.isDel = true;

    const { parentName, value } = this.props;

    this.props.dispatch({
      type: 'SkusEdit/modifySkusChild',
      option: 'delete',
      payload: {
        parentName,
        value,
      },
    });
  }

  editContent() {
    const { value } = this.state;

    return (
      <div className={styles['item-container']}>
        <Input
          ref={input => {
            this.valueInput = input;
          }}
          className={styles['item-input-container']}
          value={value}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        <Icon type="minus-circle" className={styles['item-del-icon']} onClick={this.handleDel} />
      </div>
    );
  }

  renderContent() {
    const { value } = this.state;

    return <div className={styles['render-text-container']}>{value}</div>;
  }

  render() {
    const { type } = this.props;

    return type === 'edit' ? this.editContent() : this.renderContent();
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/SkusItem/SkusChildItem/Index.js